module.exports = __webpack_public_path__ + "7b6359d5c0251a9f15bfc54be563828a.png";